import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
import { useBodyClassName } from "./useBodyClassName";
const useInfoPanel = () => {
    const [isOpen, setIsOpen] = useState(false);
    useBodyClassName(isOpen ? "" : "context-toggled");
    return { isOpen, setIsOpen };
};
const InfoPanelContext = createContext(null);
export const useInfoPanelContext = () => {
    const panel = useContext(InfoPanelContext);
    if (!panel) {
        throw new Error("useInfoPanelContext must be used within a InfoPanelProvider component.");
    }
    return panel;
};
export const InfoPanelProvider = ({ children }) => {
    const panel = useInfoPanel();
    return (_jsx(InfoPanelContext.Provider, { value: panel, children: children }));
};
